import apiFetch from '../apiFetch'

export default function (documentId, token, lastAccessDate) {
  return apiFetch({ endPoint: `document/${documentId}/cancel`, method: 'PUT', token: token, lastAccessDate })
}
